<template>
  <b-card>
    <b-row>
      <!-- Alert Notification Toggler -->
      <h6 class="section-label mx-1 mb-2">
        Alertas de notificación
      </h6>
      <b-col
        cols="12"
        class="mb-2"
      >
        <b-form-checkbox
          :checked="showAlert"
          switch
          @change="showAlert = $event"
        >
          <span>{{ showAlert ? 'Se mostrará una alerta por cada notificación recibida' : 'No se mostrarán alertas al recibir notificaciones nuevas' }}</span>
        </b-form-checkbox>
      </b-col>

      <!-- Cantidad máxima de alertas a mostrar -->
      <h6
        v-if="showAlert"
        class="section-label mx-1 mb-2"
      >
        Cantidad de alertas {{ howManyAlerts === 5 ? '(predeterminado)' : '' }}
      </h6>
      <b-col
        v-if="showAlert"
        cols="12"
        class="mb-2"
      >
        <b-form-spinbutton
          id="sb-inline"
          v-model="howManyAlerts"
          inline
          class="mr-1 mb-50"
          size="sm"
        />
        <label
          for="sb-inline"
        >Cantidad máxima de alertas emergentes que se mostrarán en un costado de la pantalla</label>
      </b-col>

      <!-- Cantidad de notificaciones a mostrar en dropdown -->
      <h6 class="section-label mx-1 mb-2">
        Cantidad de notificaciones {{ showHowMany === null ? '(Todas)' : '' }}
      </h6>
      <b-col
        cols="12"
        class="mb-2"
      >
        <b-form-spinbutton
          id="sb-inline"
          v-model="showHowMany"
          inline
          class="mr-1 mb-50"
          size="sm"
        />
        <label for="sb-inline">
          Cantidad máxima de elemenos que se mostrarán al desplegar el menú de notificaciónes de usuario en la barra de navegación
        </label>
      </b-col>

      <!-- Button -->
      <b-col cols="12">
        <b-button
          v-if="showHowMany !== null || howManyAlerts !== 5"
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          type="reset"
          class="mt-1"
          variant="outline-secondary"
          @click="showHowMany = null; howManyAlerts = 5"
        >
          Restaurar
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BButton,
  BRow,
  BCol,
  BCard,
  BFormCheckbox,

  BFormSpinbutton,
} from 'bootstrap-vue'
import useNotificacion from '@/views/campus/notificacion/useNotificacion'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BButton,
    BRow,
    BCol,
    BCard,
    BFormCheckbox,

    BFormSpinbutton,
  },
  directives: {
    Ripple,
  },
  props: {
    notificationData: {
      type: Object,
      default: () => {},
    },
  },
  setup() {
    const { showAlert, showHowMany, howManyAlerts } = useNotificacion()

    return {
      // Data
      showHowMany,
      howManyAlerts,
      showAlert,
    }
  },
}
</script>
